import api from '../api';

export default {
  namespaced: true,
  state: {
    douList: {
      // 提豆信息列表
      beanList: [],
      total: 0,
    },
    withdraw: {
      successAmount: 0,
      checkingAmount: 0,
    },
    useSdk: false,
    accountInfo: {
      bankAccName: '',
      bankAccNo: '',
      bankName: '',
      bankOfDeposit: '',
      contact: '',
    },
  },
  mutations: {
    setStateDouList(state, info) {
      state.douList = info;
    },
    setStateWithdraw(state, info) {
      state.withdraw = info;
    },
    setStateSseSdk(state, info) {
      state.useSdk = info;
    },
    setStateAccountData(state, info) {
      state.accountInfo = info;
    },
  },
  actions: {
    withdrawList({ commit }, params) {
      return api.post('/withdrawChips/list', '提豆申请列表', params).then((res) => {
        commit('setStateDouList', res.data);
        return res.data;
      });
    },
    withdrawAgree(params) {
      return api.post('/withdrawChips/agree', '提豆申请-同意', params).then((res) => {
        return res;
      });
    },
    withdrawReject(params) {
      return api.post('/withdrawChips/reject', '提豆申请-拒绝', params).then((res) => {
        return res;
      });
    },
    withdrawAccountInfo({ commit }, params) {
      return api.post(`/withdrawChips/accountInfo`, '提豆申请-账户信息', params).then((res) => {
        commit('setStateAccountData', res.data);
        return res.data;
      });
    },
    withdrawUseSdk({ commit }, params) {
      return api.post(`/withdrawChips/useSdk`, '提豆申请-是否使用sdk', params).then((res) => {
        commit('setStateSseSdk', res.data);
      });
    },
    withdrawProcessed(store, params) {
      return api.post(`/withdrawChips/processed`, '提豆申请-已处理', params).then((res) => {
        return res;
      });
    },
    withdrawFrozen(store, params) {
      return api.post(`/withdrawChips/frozen`, '提豆申请-冻结', params).then((res) => {
        return res;
      });
    },
    withdrawTotal({ commit }, params) {
      return api.post(`/withdrawChips/total`, '提豆申请-总数', params).then((res) => {
        commit('setStateWithdraw', res.data);
      });
    },
  },
};
